module.exports = __webpack_public_path__ + "static/home-hero-eb296502cf41e868383f9dc5f5797e66.jpg";